import { Heading } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import React from 'react';
import { createOptionsList } from '../../../services/common/miscUtils';
import { NoYesEnum } from '../../../types/forms';
import { RadioGroupFormControl } from '../../Fieldset/RadioGroupFormControl';
import { TextInputFormField } from '../../Fieldset/TextInputFormField';

export const createFormInputs = (disabled = false) => {
  return {
    majorityInCompanies: () => (
      <>
        <Heading level={6} className="u-mb-small u-text-left">
          {t('linkedRelationshipsForm:linkedRelationshipsForm.majorityInCompanies.label')}
        </Heading>

        <RadioGroupFormControl
          fieldName="majorityInCompanies"
          optionList={createOptionsList(NoYesEnum, 'linkedRelationshipsForm', 'noYes', null)}
          isDisabled={disabled}
        />
      </>
    ),
    majorityInCompaniesCompanyName: () => (
      <TextInputFormField
        fieldName="majorityInCompaniesCompanyName"
        labelTranslationKey="linkedRelationshipsForm:linkedRelationshipsForm.majorityInCompaniesCompanyName.label"
        placeholderTranslationKey="linkedRelationshipsForm:linkedRelationshipsForm.majorityInCompaniesCompanyName.placeholder"
        isDisabled={disabled}
      />
    ),
    partnerOfCompanies: () => (
      <>
        <Heading level={6} className="u-mb-small u-text-left">
          {t('linkedRelationshipsForm:linkedRelationshipsForm.partnerOfCompanies.label')}
        </Heading>

        <RadioGroupFormControl
          fieldName="partnerOfCompanies"
          optionList={createOptionsList(NoYesEnum, 'linkedRelationshipsForm', 'noYes', null)}
          isDisabled={disabled}
        />
      </>
    ),
    partnerOfCompaniesCompanyName: () => (
      <TextInputFormField
        fieldName="partnerOfCompaniesCompanyName"
        labelTranslationKey="linkedRelationshipsForm:linkedRelationshipsForm.partnerOfCompaniesCompanyName.label"
        placeholderTranslationKey="linkedRelationshipsForm:linkedRelationshipsForm.partnerOfCompaniesCompanyName.placeholder"
        isDisabled={disabled}
      />
    ),
    customerOfVwfs: () => (
      <>
        <Heading level={6} className="u-mb-small u-text-left">
          {t('linkedRelationshipsForm:linkedRelationshipsForm.customerOfVwfs.label')}
        </Heading>

        <RadioGroupFormControl
          fieldName="customerOfVwfs"
          optionList={createOptionsList(NoYesEnum, 'linkedRelationshipsForm', 'noYes', null)}
          isDisabled={disabled}
        />
      </>
    ),
    contactNumberOrVehicleRegistrationNumber: () => (
      <TextInputFormField
        fieldName="contactNumberOrVehicleRegistrationNumber"
        labelTranslationKey="linkedRelationshipsForm:linkedRelationshipsForm.contactNumberOrVehicleRegistrationNumber.label"
        placeholderTranslationKey="linkedRelationshipsForm:linkedRelationshipsForm.contactNumberOrVehicleRegistrationNumber.placeholder"
        isDisabled={disabled}
      />
    ),
  };
};
